import { Skeleton } from "@mantine/core";
import { Order } from "@/types";
import AccordionMaterial from "./Accordions/AccordionMaterial";
import AccordionLogistics from "./Accordions/AccordionLogistics";
import AccordionGeneral from "./Accordions/AccordionGeneral";
import AccordionFinalAmount from "./Accordions/AccordionFinalAmount";
import AccordionOrderActions from "./Accordions/AccordionOrderActions";
import { useOrderInspectionView } from "../../useOrderInspectionView";

interface DetailsTabProps {
  order: Order;
}

const DetailsTab = ({ order }: DetailsTabProps) => {
  const { isLoading: isLoadingInspection, view: inspectionView } = useOrderInspectionView(order);

  return (
    <>
      <AccordionOrderActions order={order} />

      <AccordionGeneral order={order} />

      <AccordionMaterial order={order} />

      <AccordionLogistics order={order} />

      {/* Either or: an inspected order gets its weight from the Inspeksjon tab, not the final amount flow. */}
      {isLoadingInspection && <Skeleton height={56} />}
      {!isLoadingInspection && inspectionView.kind === "none" && <AccordionFinalAmount order={order} />}
    </>
  );
};

export default DetailsTab;
